var exports = {
  "K": "shared.module__icon___N3U0LU",
  "B": "shared.module__iconSmall___N3U0LU",
};

module.exports = exports;
